import apiFetch from '../apiFetch'

export default function (value) {
  return apiFetch({endPoint: `Recta/cambiarRectaPredeterminada?idRecta=` + value, method: 'GET', body: null})
}